import "./bulma.css";
import "./main.css";

// even though Rollup is bundling all your files together, errors and
// logs will still point to your original source modules
//console.log('PEFif you have sourcemaps enabled in your devtools, click on main.js:5 -->');

window.onload = () => {
    // document.addEventListener("keydown", function (event) {
    //     var e = event || window.event;
    //     if (e.key == "Escape") {
    //       closeModal();
    //     }
    //   });
}

export function toggleBurger() {
    (document.querySelector(".burger") as Element)!.classList.toggle(
        "is-active"
    );
    (document.querySelector(".navbar-menu") as Element)!.classList.toggle(
        "is-active"
    );
}

export function showModal() {
    (document.querySelector("html") !as Element).classList.toggle("is-clipped");
    (document.querySelector("#choiceModal") !as Element).classList.toggle("is-active");
}

export function closeModal() {
    (document.querySelector("#choiceModal") !as Element).classList.toggle("is-active");
    (document.querySelector("html") !as Element).classList.toggle("is-clipped");
}

